<template>
	<div class="layout-topbar">
		<ConfirmDialog></ConfirmDialog>
		<!-- <Toast /> -->
		<div class="layout-topbar-logo" @click="$router.push({path: '/'})">
			<!-- <h1 class="logo" style="color: white">伴生质子束用户系统</h1> -->
			<img v-if="isMobile" src="./assets/images/logo.png" style="height: 30px;" class="logo" alt="Associated proton"/>
            <img v-else src="./assets/images/logo.png" style="height: 50px;" class="logo" alt="Associated proton"/>
        </div>

        <a class="layout-menu-button" href="#" @click="onMenuButtonClick">
            <i class="pi pi-bars"></i>
        </a>

		<ul class="layout-topbar-menu">
			<li :class="[{'active-topmenuitem': activeTopbarItem === 'settings'}]" class="layout-topbar-item"
				@click="$emit('topbar-item-click',{originalEvent:$event,item:'settings'})">
				<a class="layout-topbar-icon first" @click="userProfileDialogDisplay=true" v-tooltip.left="'用户信息'">
					<i class="topbar-icon pi pi-user"></i>
					<!-- <i class="topbar-icon fa fa-camera-retro fa-3x" style="color: white"></i> -->
				</a>
			</li>
			<li :class="[{'active-topmenuitem': activeTopbarItem === 'settings'}]" class="layout-topbar-item"
				@click="$emit('topbar-item-click',{originalEvent:$event,item:'settings'})">
				<a class="layout-topbar-icon first" @click="exitConfirm" v-tooltip.left="'退出登录'">
					<i class="topbar-icon pi pi-power-off"></i>
					<!-- <i class="topbar-icon fa fa-camera-retro fa-3x" style="color: white"></i> -->
				</a>
			</li>

			<li :class="[{'active-topmenuitem': activeTopbarItem === 'profile'}]" class="user-profile"
				@click="$emit('topbar-item-click',{originalEvent:$event,item:'profile'})">
				<a href="#">
					<div class="user-profile-info profile-link" v-if="userInfo">
						<span class="user-profile-name">{{userInfo.email}}</span>
						<span class="user-profile-role">{{userInfo.name}}</span>
					</div>
					<!-- <img class="logo" src="assets/layout/images/avatar/avatar-ava.jpg" alt="prestige-layout" /> -->
					<img class="logo" src="/assets/layout/images/avatar/avatar-proton.png" alt="prestige-layout" />
					<!-- <i class="fa fa-camera-retro fa-3x" style="z-index: 999; color: white"></i> -->
				</a>
				<transition name="layout-submenu-container">
					<ul class="fadeInDown" v-show="activeTopbarItem === 'profile'">
						<li class="profile-detail">
							<div class="user-profile-info">
								<!-- <img class="logo" src="assets/layout/images/avatar/avatar-ava.jpg" alt="prestige-layout" /> -->
								<img class="logo" src="/assets/layout/images/avatar/avatar-proton.png" alt="prestige-layout" />
								<div class="profile-info" v-if="userInfo">
									<span class="user-profile-name">{{userInfo.email}}</span>
									<span class="user-profile-role">{{userInfo.name}}</span>
								</div>
								<!-- <a href="#" class="profile-detail-icon" >
									<i class="pi pi-sign-out"></i>
								</a> -->
							</div>
						</li>
						<li>
							<a href="#" @click="userProfileDialogDisplay=true" >
								<i class="pi pi-user"></i>
								<div class="menu-text">
									<span class="menu-title">Profile</span>
									<span class="menu-subtitle">Display your profile</span>
								</div>

								<!-- <i class="right-icon pi pi-angle-right"></i> -->
							</a>
						</li>
						<li>
							<a href="#" @click="exitConfirm">
								<i class="pi pi-power-off"></i>
								<div class="menu-text">
									<span class="menu-title">Logout</span>
									<span class="menu-subtitle">Exit the system</span>
								</div>
								<!-- <i class="right-icon pi pi-angle-right"></i> -->
							</a>
						</li>
					</ul>
				</transition>
			</li>
		</ul>

	<Dialog header="用户信息" v-model:visible="userProfileDialogDisplay" :modal="true">
		<div class="p-grid" v-if="userInfo">
			<div class="p-col-12">
				<p> 姓名: {{ userInfo.name }}</p>
			</div>
			<div class="p-col-12">
				<p> 邮箱: {{ userInfo.email }}</p>
			</div>
		</div>
		
		<template #footer>
			<Button label="关闭" icon="pi pi-times" style="margin-right: 1em" @click="userProfileDialogDisplay=false" />
		</template>
	</Dialog>

	<Dialog header="消息确认" v-model:visible="sessionExpireDialogDisplay" :style="{width: '30vw'}" :modal="true" :closable="false">
		<div style="color: orange; font-weight: bold">
			<i class="fa fa-exclamation-triangle fa-2x" style="vertical-align: middle; color: orange"></i>
			<span class="p-text-center p-ml-2" style="vertical-align: middle">会话超时，即将退出登录！</span>
		</div>

		<template #footer>
			<Button label="确定" icon="pi pi-check" @click="logout" />
		</template>
	</Dialog>

	</div>
	
</template>

<script>
	import config from './config/configuration.js';
	import AuthenticationService from './service/AuthenticationService';
	const jwt = require('jsonwebtoken');

	export default {
		data() {
			return {
				intervalId: null,
				sessionExpireDialogDisplay: false,
				displayConfirmation: false,
				userProfileDialogDisplay: false,
				authenticationService: null
			}
		},
		emits: ['topbar-item-click', 'menubutton-click', 'topbar-menubutton-click'],
		props: {
			topbarMenuActive: Boolean,
			horizontal: Boolean,
			activeTopbarItem: String
		},
		created () {
			this.authenticationService = new AuthenticationService();

			this.checkSessionStatus();
			this.intervalId = setInterval(this.checkSessionStatus, 60000);
		},
		methods: {
			// Check session validity every 60 seconds
			checkSessionStatus() {
				// console.log("checkSessionStatus");
				const user = JSON.parse(localStorage.getItem(config.localStorageUser));
				if(!user) return;

				var token = user.token;
				// get the decoded payload and header
				var decoded = jwt.decode(token, {complete: true});

				var dateNow = new Date();
				// console.log(decoded.payload.exp);
				// console.log(dateNow / 1000);
				if(decoded.payload.exp < dateNow / 1000) {
					console.log("JWT token expired!!!");
					this.sessionExpireDialogDisplay = true;
				}
			},
			exitConfirm() {
				this.$confirm.require({
					message: '确定要退出登录吗?',
					header: '消息确认',
					icon: 'pi pi-exclamation-triangle',
					acceptLabel: '确定',
					rejectLabel: '取消',
					accept: () => {
						this.logout();
						// this.$toast.add({severity:'info', summary:'Confirmed', detail:'You have accepted', life: 3000});
					},
					reject: () => {
						// this.$toast.add({severity:'error', summary:'Rejected', detail:'You have rejected', life: 3000});
					}
				});
			},
			logout() {
				this.$store.dispatch('authentication/logout')
				.then(() => {
					console.log("logout done");
					// window.location.href = "https://login.csns.ihep.ac.cn/logout?WebServerURL=http://localhost:8080";
					window.location.href = this.authenticationService.logoutFullUrl();
				})
				// this.$router.push({name: 'Home'});
			},
			onMenuButtonClick(event) {
				this.$emit('menubutton-click', event);
			},
			onTopbarMenuButtonClick(event) {
				this.$emit('topbar-menubutton-click', event);
			}
		},
		computed: {
			userInfo() {
				return this.$store.state.authentication.user;
			},
			isMobile() {
				// console.log(screen.width);
				// console.log(typeof screen.width);
				return screen.width <= 760 ? true : false;
			},
			screenWidth() {
				return screen.width;
			},
		}
	}
</script>
